import { LatLngExpression, } from 'leaflet';
import React, { useContext, useMemo } from "react";
import {
  Marker,
} from 'react-leaflet';

import { nanoid } from 'nanoid';
import { AccountContext } from '../context/account';
import { MapDataContext } from '../context/map-data';
import { ProjectItem } from '../core/global';
import { isNumber } from '../helpers/core';
import { ColourOptions, createMarkerIcon } from '../helpers/marker-icons';

interface ProjectPointProps {
  point: LatLngExpression
  iconColor?: ColourOptions
  onClick?: (e: any) => void
}

export const ProjectPoint = ({
  point,
  iconColor = 'purple',
  onClick
}: ProjectPointProps ) => {
  return (
    <Marker 
      icon={createMarkerIcon(iconColor)} 
      opacity={1} 
      position={point}
      eventHandlers={{
        click: (e) => {
          if (onClick) onClick(e)
        },
      }}
    
    />
  )
}
interface MapProjectsPointsProps {
  activeLocation?: [number, number]
  showActiveOnly?: boolean
}

export const MapProjectPoints = ({
  activeLocation,
  showActiveOnly,
}: MapProjectsPointsProps ) => {

  const { 
    projectPoints,
    projects,
    showProjectPointsOnMap,
  } = useContext(AccountContext);

  const { 
    updateMeshData,
    setMapCenter,
    setDataSourceModel,
  } = useContext(MapDataContext);

  const mergedPoints: (LatLngExpression | ProjectItem)[] = useMemo(() => {
    if (showProjectPointsOnMap) {
      return [...projectPoints, ...projects]
    }
    return []
  }, [projects, projectPoints, showProjectPointsOnMap])

  if (typeof window === "undefined") {
    return null
  }

  return (
    <>
      {
        mergedPoints.map((point: LatLngExpression | ProjectItem) => {
          let iconColor: ColourOptions = 'purple'
          let lat: number | null = null
          let lon: number | null = null
          if (Array.isArray(point) && point && Array.isArray(point)) {
            [lat, lon] = point
            if (activeLocation && lat !== null && lon !== null) {
              const [activeLat, activeLon] = activeLocation
              if (Number(lat).toFixed(5) === activeLat.toFixed(5) && Number(lon).toFixed(5) === activeLon.toFixed(5)) {
                iconColor = 'yellow'
              }
            }
          } else {
            const {lat: _lat, lon: _lon, model} = point as ProjectItem
            lat = _lat || null
            lon = _lon || null
            iconColor = model === 'swan' ? 'wavegreen' : 'levelgreen'
          }

          const usePoint = [Number(lat), Number(lon)]

          if (showActiveOnly && iconColor !== 'yellow') {
            return null
          }
          return (
            <React.Fragment key={nanoid()}>
              <ProjectPoint 
                point={[lat as number, lon as number]} 
                iconColor={iconColor} 
                onClick={() => {
                  if (point && isNumber(lat) && isNumber(lon)) {
                    if (!Array.isArray(point)) {
                      const {provider, model, geography, version} = point as ProjectItem
                      const projectModel = {
                        key: `${provider}-${model}-${geography}-${version}`,
                        provider,
                        model,
                        geography,
                        version,
                      }
                      setDataSourceModel(projectModel)
                      updateMeshData({coords: `${lat}, ${lon}`, useModel: projectModel})
                    } else {
                      const [lat, lon] = usePoint
                      updateMeshData({coords: `${lat}, ${lon}`})
                      setMapCenter({location: {lat, lng: lon}})
                    }
                      
                }
                }} 
              />
            </React.Fragment>
          )
        })

    }
    </>
  )

};